import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Foundation from "@/pages/Foundation";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import HealthcareNews from "@/pages/HealthcareNews";
import Dispatcher from "@/pages/Dispatcher";
import Driver from "@/pages/Driver";
import Patient from "@/pages/Patient";
import Group from "@/pages/Group";
import Estimate from "@/pages/Estimate";
import LiveTracker from "@/pages/LiveTracker";
import Admin from "@/pages/Admin";
import HomeCare from "@/pages/HomeCare";
import Caregiver from "@/pages/Caregiver";
import NotFound from "@/pages/NotFound";

// Standalone app-like routes: no marketing chrome (nav/footer)
const CHROMELESS_ROUTES = ["/driver", "/patient", "/live", "/group", "/admin", "/homecare", "/caregiver"];

// Legacy: old reset emails linked to /admin/setup?reset=<token>. Redirect them to /admin?reset=<token>.
function AdminSetupRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/admin${search}`} replace />;
}

function AppShell() {
  const { pathname } = useLocation();
  const isChromeless = CHROMELESS_ROUTES.some((p) => pathname.startsWith(p));
  return (
    <>
      {!isChromeless && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/foundation" element={<Foundation />} />
          <Route path="/healthcare-news" element={<HealthcareNews />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dispatcher" element={<Dispatcher />} />
          <Route path="/driver" element={<Driver />} />
          <Route path="/patient" element={<Patient />} />
          <Route path="/group" element={<Group />} />
          <Route path="/estimate" element={<Estimate />} />
          <Route path="/live/:token" element={<LiveTracker />} />
          <Route path="/admin" element={<Admin />} />
          {/* Legacy alias for old reset-email URLs that pointed at /admin/setup?reset=… */}
          <Route path="/admin/setup" element={<AdminSetupRedirect />} />
          <Route path="/homecare" element={<HomeCare />} />
          <Route path="/caregiver" element={<Caregiver />} />
          <Route path="/caregiver/:token" element={<Caregiver />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isChromeless && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <AppShell />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
